<template>
  <div class="container">
    <h2>{{ section.field_2 }}</h2>
    <p v-if="section.field_3" v-html="section.field_3"></p>
    <transition-group name="articles" tag="div" class="row">
      <div
        v-for="(article, index) in pages.loaded"
        class="col-12 col-md-6 col-lg-4"
        v-bind:key="index + article.slug">
        <a class="item news_item_link" :href="article.url">
          <div
            class="image bglazyload"
            :data-src="article.list_image_url">
          </div>
          <div class="copy">
            <div class="article-category">{{ article.category }}</div>
            <div class="article-title" :class="{'long-article-title' : hasLongTitle(article.name)}">{{ article.name }}</div>
          </div>
          <div class="btn-square">
            <i class="icon icon-arrow"></i>
          </div>
        </a>
      </div>
    </transition-group>
    <button
      v-if="showButton"
      v-on:click="getPages"
      class="article-list-btn btn btn-white-blue btn-hover">
      {{ load_more }}
    </button>
    <p v-if="page == 1 && result_empty">No results</p>
    <div v-else class="article-list-loader">
      <img
        style="height: 100px"
        v-if="showLoader"
        src="/cdn/images/loading.gif"
        class="loader"
      />
    </div>
  </div>
</template>
<script>
import ObserveForLazyLoad from "../../js/lazyload";
export default {
  props: {
    section: {
      section: Object,
      required: true,
    },
    load_more: {
      section: String,
      default: "Load More",
    },
    page_type: {
      section: Number,
      default: 2,
    },
  },
  data() {
    return {
      page: 1,
      result_empty: false,
      endpoint: "api/article-list-items/",
      pages: {
        loaded: [],
        preloaded: [],
      },
      showLoader: false,
      showButton: false,
    };
  },
  mounted() {
    this.getPages();
  },
  updated() {
    ObserveForLazyLoad.ObserveForLazyLoad();
  },
  methods: {
    async getPages() {
      try {
        this.showLoader = true;

        let pageTypeId = this.page_type;
        let pageLength = this.section.field_4 ? this.section.field_4 : 9;
        let apiUrl =
          this.endpoint + [pageTypeId, pageLength, this.page].join("/");
        let response = await axios.post(apiUrl, { data: this.section.field_1 });
        let data = response.data.data;

        if (this.pages.loaded.length === 0) {
          this.pages.loaded = data;
          this.page++;
          this.getPages();
        } else if (this.pages.preloaded.length === 0) {
          this.pages.preloaded = data;
          this.toggleLoadMoreButton(data);
          this.page++;
        } else {
          this.$set(
            this.pages,
            "loaded",
            this.pages.loaded.concat(this.pages.preloaded)
          );
          // this.pages.loaded = this.pages.loaded.concat(this.pages.preloaded);
          this.pages.preloaded = data;
          this.toggleLoadMoreButton(data);
          this.page++;
        }

        this.showLoader = false;
      } catch (err) {
        console.log(err);
      }
    },
    toggleLoadMoreButton(data) {
      if (data.length === 0) {
        this.showButton = false;
      } else {
        this.showButton = true;
      }
    },
    hasLongTitle(title) {
      if (title.length > 110) {
        return true;
      }

      return false;
    }
  },
};
</script>

<style scoped lang="scss">
.article-list {
  .item {
    .article-title {
      &.long-article-title {
        font-size: 1.3rem;
      }
    }
  }
}
</style>